/* eslint-disable react/display-name */
/**
 *
 * ReportDetail
 *
 */

import { memo, useEffect, useState } from 'react';

import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { Row } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import { downloadFile } from 'app/components/form/file/file.sevice';
import { PaginableGrid } from 'app/components/grid/common';
import { GridContainer, OnlyGrid } from 'app/components/grid/gridApplication';
import { usePaginateApplication } from 'app/hooks';
import { useGetTaxReportGeneral } from 'app/modules/Reports/hooks';
import { baseUrlReports, getFormReportDefinition } from 'app/modules/Reports/http';
import saveAs from 'file-saver';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { label } from '../../../TaxStatement/FormCells/translation';

interface Props {}

export const ReportDetail = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<Record<string, string>>();
  const { data, loading, error } = useGetTaxReportGeneral(id ?? '');
  const [colDef, setColDef] = useState<any>([]);
  const [definitionRow, setDefinitionRow] = useState<any>([]);

  const [search, setSerach] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [{ data: paginable, loading: loadingList, error: errorList }, execute] =
    usePaginateApplication<any>(
      baseUrlReports + '/tax-report/' + (id ?? '') + '/details',
      page,
      perPage,
      search
    );

  const download = async () => {
    const response: any = await downloadFile(data.attachment);
    fetch('data:application/octet-stream;base64,' + response.content)
      .then((res) => res.blob())
      .then((blob: any) => saveAs(blob, response.name));
  };
  useEffect(() => {
    const fetchData = async () => {
      if (data && data.year && definitionRow.length === 0) {
        const result = await getFormReportDefinition(
          data?.reportId,
          data?.year,
          data?.periodicityItemId
        );

        setDefinitionRow(result.columns);
      }
    };

    fetchData();
  }, [data]);

  // const buildGuidData = async (page: number, pageSize: number, param: any) => {
  //   const result = await TaxReportDetailsList(id, page, pageSize, param);
  //   if (colDef.length == 0) {
  //     const colDef: ColDef[] = [];
  //     for (const key of Object.keys(result.data[0].record)) {
  //       colDef.push({
  //         headerName: key.toUpperCase(),
  //         field: '',
  //         valueGetter: (params: any) => {
  //           const value = params.data.record[key];
  //           if (typeof value === 'boolean') {
  //             if (value) {
  //               return t('common.yes-no.yes');
  //             } else {
  //               return t('common.yes-no.no');
  //             }
  //           }
  //           return value;
  //         }
  //       });
  //     }
  //     setColDef(colDef);
  //   }
  //   return result;
  // };

  useEffect(() => {
    if (paginable) {
      if (colDef.length == 0) {
        const colDef: Array<ColDef> = [];
        for (const key of Object.keys(paginable.data[0].record)) {
          colDef.push({
            headerName: key.toUpperCase(),
            field: '',
            valueGetter: (params: any) => {
              const value = params.data.record[key];
              if (typeof value === 'boolean') {
                if (value) {
                  return t('common.yes-no.yes');
                } else {
                  return t('common.yes-no.no');
                }
              }
              return value;
            }
          });
        }
        setColDef(colDef);
      }
    }
  }, [paginable]);

  const colDefsDetail = [
    {
      headerName: label(t, 'name'),
      field: 'header'
    },
    {
      headerName: label(t, 'type'),
      cellRenderer: (params: any) => label(t, params.data.type)
    },
    {
      headerName: label(t, 'description'),
      field: 'description'
    }
  ];
  if (loading) {
    return <></>;
  }
  return (
    <>
      <PageTitle title={t('report-details.title.page')} />

      <Row>
        <Col>
          <Form.Group controlId="reportNumber">
            <Form.Label>{t('report-details.label.reportNumber')}</Form.Label>
            <Form.Control type="text" disabled value={data?.taxReportNumber ?? ''} />
          </Form.Group>
        </Col>

        <Col>
          <Form.Group controlId="period">
            <Form.Label>{t('report-details.label.period')}</Form.Label>
            <Form.Control type="text" disabled value={data?.period ?? ''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group controlId="reportName">
            <Form.Label>{t('report-details.label.reportName')}</Form.Label>
            <Form.Control type="text" disabled value={data?.reportName ?? ''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group controlId="taxpayerid">
            <Form.Label>{t('report-details.label.taxpayerNumber')}</Form.Label>
            <Form.Control type="text" disabled value={data?.taxpayer?.tin ?? ''} />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="taxpayerName">
            <Form.Label>{t('report-details.label.taxpayerName')}</Form.Label>
            <Form.Control type="text" disabled value={data?.taxpayer?.name ?? ''} />
          </Form.Group>
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col>
          <GridContainer autoHeight={true}>
            <OnlyGrid domLayout={'autoHeight'} columnDefs={colDefsDetail} data={definitionRow} />
          </GridContainer>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          {/*<Grid*/}
          {/*  service={async (page: number, pageSize: number, param: any) => {*/}
          {/*    return buildGuidData(page, pageSize, param);*/}
          {/*  }}*/}
          {/*  columnDefs={colDef}*/}
          {/*/>*/}

          {colDef?.length > 0 && (
            <GridContainer>
              {paginable && (
                <PaginableGrid data={paginable} columnDefs={colDef} page={page} setPage={setPage} />
              )}
            </GridContainer>
          )}
        </Col>
      </Row>
      <hr />
      <hr />
      <BtnToolbar>
        <BtnGroup>
          <Button
            action={ButtonAction.cancel}
            variant="secondary"
            onClick={() => {
              navigate('/reports/details');
            }}
          />
        </BtnGroup>
        <BtnGroup>
          <Button
            action={ButtonAction.download}
            onClick={() => {
              download();
            }}
          />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
});
